import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  Fragment,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  Modal,
  Paper,
  Button,
  Typography,
  IconButton,
  Box,
  Divider,
  useTheme,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
  useMediaQuery,
  Stack,
  CircularProgress,
  alpha,
} from "@mui/material";
import {
  Close,
  PlayArrowOutlined,
  PlaylistAdd,
  Save,
  SaveAs,
} from "@mui/icons-material";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import { LoadingButton } from "@mui/lab";
import NewAlertModal from "../../../componentes/newAlertModal";
import ConfigureHost from "./configureHost";
import styled from "styled-components";
import ConnectivityTests from "./connectivityTests";

const styles = {
  paper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "600px",
    maxHeight: { xs: "620px", sm: "562.5px" },
    minHeight: "562.5px",
    overflowY: "auto",
    borderRadius: "8px",
    padding: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  boxHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    mb: 1,
  },
  boxTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    color: "primary.main",
    width: "100%",
  },
  boxRowFields: {
    display: "flex",
    flexDirection: "column",
    with: "100%",
    gap: 0.5,
  },
  subtitle: {
    fontSize: "14px",
    fontWeight: 500,
    color: "text.primary",
  },
};
const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.sucess.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.sucess.main,
    },
  },
}));

const ipRegex =
  /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const regexFinalString =
  /(?:\b(?:25[0-5]|2[0-4]\d|1?\d?\d)(?:\.(?:25[0-5]|2[0-4]\d|1?\d?\d)){3}|\b(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|\b(?:[0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|\b:(?::[0-9a-fA-F]{1,4}){1,7}|::)$/;

const initialFormState = {
  nome: "",
  ip: "",
  comunidadeSnmp: "",
  portaSNMP: 161,
  fabricante: "",
  modelo: "",
  userSsh: "",
  senhaSsh: "",
  portaSsh: 22,
  userTelnet: "",
  senhaTelnet: "",
  portaTelnet: 23,
  proxy: "0",
  tipoAcesso: "",
  tipoSNMP: "",
};

const optionsTipoAcesso = ["SSH", "Telnet"];

const optionsTipoInterfaceSNMP = [
  { tipoInterface: "AGENTE", porta: 10050 },
  { tipoInterface: "SNMPv1", porta: 161 },
  { tipoInterface: "SNMPv2", porta: 161 },
];

const FormHostModal = forwardRef(
  (
    {
      open = false,
      onClose = () => {},
      onSave = () => {},
      templates = [],
      loading = false,
      proxys = [],
      hostData,
      setEditingHostData,
    },
    ref,
  ) => {
    const [form, setForm] = useState(initialFormState);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [openAlertModal, setOpenAlertModal] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [isTesting, setIsTesting] = useState(false);
    const [testsLocal, setTestsLocal] = useState({ ping: null, snmp: null });
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    useEffect(() => {
      if (activeStep === 2 && loading) {
        setHasSubmitted(true);
      }
      if (activeStep !== 2) {
        setHasSubmitted(false);
      }
    }, [activeStep, loading]);

    const fabricantesOptions = useMemo(() => {
      if (!Array.isArray(templates)) return [];
      return templates
        .map((item) => item.fabricante.toUpperCase())
        .filter(Boolean);
    }, [templates]);

    const modelosDisponiveis = useMemo(() => {
      if (!form.fabricante || !Array.isArray(templates)) return [];

      const fabricante = templates.find(
        (t) => t.fabricante.toLowerCase() === form.fabricante.toLowerCase(),
      );

      if (!fabricante && !Array.isArray(fabricante?.Funcoes)) return [];

      return fabricante.Funcoes.flatMap((f) =>
        f.Modelos.map((m) => ({
          label: `${f.funcao} - ${m.modelo}`,
          value: m.id,
          predefinicoes: m.Predefinicoes?.config,
        })),
      );
    }, [form.fabricante, templates]);

    const getFormErrors = useCallback((formState) => {
      const errs = {};
      if (!formState.nome?.trim()) errs.nome = "Nome é obrigatório";
      if (!formState.ip?.trim()) errs.ip = "IP é obrigatório";
      else if (!ipRegex.test(formState.ip))
        errs.ip = "O IP digitado não é válido";
      if (formState.tipoSNMP !== "AGENTE" && !formState.comunidadeSnmp?.trim())
        errs.comunidadeSnmp = "Comunidade SNMP é obrigatória";
      if (!formState.portaSNMP) errs.portaSNMP = "Porta SNMP é obrigatória";
      if (!formState.fabricante) errs.fabricante = "Fabricante é obrigatório";
      if (!formState.modelo) errs.modelo = "Modelo é obrigatório";
      if (formState.tipoAcesso === "SSH") {
        if (!!formState.userSsh?.trim() || !!formState.senhaSsh?.trim()) {
          if (!formState.userSsh?.trim())
            errs.userSsh = "Usuário é obrigatório";
          if (!formState.senhaSsh?.trim())
            errs.senhaSsh = "Senha é obrigatória";
          if (!formState.portaSsh) errs.portaSsh = "Porta é obrigatória";
        }
      } else if (formState.tipoAcesso === "Telnet") {
        if (!!formState.userTelnet?.trim() || !!formState.senhaTelnet?.trim()) {
          if (!formState.userTelnet?.trim())
            errs.userTelnet = "Usuário é obrigatório";
          if (!formState.senhaTelnet?.trim())
            errs.senhaTelnet = "Senha é obrigatória";
          if (!formState.portaTelnet) errs.portaTelnet = "Porta é obrigatória";
        }
      }
      return errs;
    }, []);

    const initializeForm = useCallback(() => {
      if (hostData && Object.keys(hostData).length > 0 && hostData.ip) {
        const isSSH = !!(
          hostData.userSsh ||
          hostData.portaSsh ||
          hostData.senhaSsh
        );

        const isTelnet =
          !isSSH &&
          !!(
            hostData.userTelnet ||
            hostData.portaTelnet ||
            hostData.senhaTelnet
          );

        const proxy = proxys.find(
          (p) => p.host.toLowerCase() === (hostData.proxy || "").toLowerCase(),
        );

        let interfaceHost = "SNMPv1";
        if (hostData.interfaceType === "1") interfaceHost = "AGENTE";
        else if (hostData.interfaceType === "2" && hostData.tipoSnmp === "2")
          interfaceHost = "SNMPv2";

        setForm({
          nome: hostData.nome || "",
          ip: hostData.ip || "",
          comunidadeSnmp: hostData.comunidade || "",
          portaSNMP: hostData.portaSnmp || 161,
          userSsh: hostData.userSsh || "",
          senhaSsh: hostData.senhaSsh || "",
          portaSsh: hostData.portaSsh || 22,
          userTelnet: hostData.userTelnet || "",
          senhaTelnet: hostData.senhaTelnet || "",
          portaTelnet: hostData.portaTelnet || 23,
          fabricante: hostData.fabricante || "",
          modelo: "",
          proxy: proxy ? proxy.proxyid : "0",
          tipoAcesso: isSSH ? "SSH" : isTelnet ? "Telnet" : "",
          tipoSNMP: interfaceHost,
        });
      } else {
        const zabbixProxy = proxys.find(
          (p) => p.host.toLowerCase() === "zabbix-proxy",
        );
        setForm({
          ...initialFormState,
          proxy: zabbixProxy ? zabbixProxy.proxyid : "0",
        });
      }
    }, [hostData, proxys]);

    useEffect(() => {
      if (
        open &&
        hostData?.modelo &&
        !form.modelo &&
        modelosDisponiveis.length > 0
      ) {
        const modelo = modelosDisponiveis.find(
          (m) => m.label.toLowerCase() === hostData.modelo.toLowerCase(),
        );

        if (modelo) {
          setForm((prev) => ({ ...prev, modelo: modelo.value }));
        }
      }
    }, [open, hostData?.modelo, modelosDisponiveis, form.modelo]);

    useEffect(() => {
      if (open) {
        setErrors({});
        setTouched({});
        initializeForm();
      }
    }, [open]);

    const handleChange = (e) => {
      const { name, value } = e.target;
      let newForm;

      if (name === "fabricante") {
        newForm = { ...form, fabricante: value, modelo: "" };
      } else if (name === "tipoSNMP") {
        newForm = {
          ...form,
          tipoSNMP: value?.tipoInterface,
          portaSNMP: value?.porta,
          ...(value?.tipoInterface === "AGENTE" && {
            userSsh: "",
            senhaSsh: "",
            portaSsh: 22,
            userTelnet: "",
            senhaTelnet: "",
            portaTelnet: 23,
            tipoAcesso: "",
          }),
        };
      } else if (name === "tipoAcesso") {
        newForm = {
          ...form,
          tipoAcesso: value,
        };
      } else {
        newForm = { ...form, [name]: value };
      }

      setForm(newForm);

      const newTouched = { ...touched, [name]: true };
      setTouched(newTouched);

      const allErrors = getFormErrors(newForm);
      const visibleErrors = {};
      Object.keys(newTouched).forEach((field) => {
        if (allErrors[field]) visibleErrors[field] = allErrors[field];
      });
      setErrors(visibleErrors);
    };

    const handleIpBlur = () => {
      setTouched((prev) => ({ ...prev, ip: true }));
      const allErrors = getFormErrors(form);
      if (allErrors.ip) setErrors((prev) => ({ ...prev, ip: allErrors.ip }));
    };

    const handleCreateHost = () => {
      const newErrors = getFormErrors(form);
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      }
      let selectedTemplates = [];
      let selectedMacros = [];
      let selectedGroups = [];
      let modeloData = null;
      let funcaoData = null;

      const fabricanteData = templates.find(
        (item) =>
          item.fabricante.toLowerCase() === form.fabricante.toLowerCase(),
      );

      if (
        fabricanteData &&
        form.modelo &&
        Array.isArray(fabricanteData?.Funcoes)
      ) {
        for (const funcao of fabricanteData.Funcoes) {
          const modelo = funcao.Modelos?.find((m) => m.id === form.modelo);

          if (modelo) {
            funcaoData = funcao;
            modeloData = modelo;
            break;
          }
        }
        const predefinicoes = modeloData?.Predefinicoes;

        if (predefinicoes) {
          try {
            selectedTemplates = predefinicoes.templates
              ? JSON.parse(predefinicoes.templates)
              : [];
            selectedMacros = predefinicoes.macros
              ? JSON.parse(predefinicoes.macros)
              : [];
            selectedGroups = predefinicoes.groups
              ? JSON.parse(predefinicoes.groups)
              : [];
          } catch (error) {
            selectedTemplates = [];
            selectedMacros = [];
          }
        }
      }
      const nameIp = regexFinalString.test(form?.nome?.trim());
      const modeloName = modeloData?.modelo || null;
      const funcaoName = funcaoData?.funcao || null;

      const finalObject = {
        nome: nameIp
          ? form?.nome?.trim()
          : `${form?.nome?.trim()} - ${form?.ip?.trim()}`,
        ip: form.ip.trim(),
        ...(form.tipoSNMP !== "AGENTE" && {
          comunidadeSnmp: form.comunidadeSnmp.trim(),
          userAcesso:
            (form.tipoAcesso === "SSH"
              ? form.userSsh.trim()
              : form.userTelnet.trim()) || null,
          senhaAcesso:
            (form.tipoAcesso === "SSH"
              ? form.senhaSsh.trim()
              : form.senhaTelnet.trim()) || null,
          portaAcesso:
            (form.tipoAcesso === "SSH"
              ? Number(form.portaSsh)
              : Number(form.portaTelnet)) || null,
          tipoAcesso:
            form.tipoAcesso === "SSH"
              ? 0
              : form.tipoAcesso === "Telnet"
                ? 1
                : null,
        }),
        portaSNMP: Number(form.portaSNMP),
        fabricante: form.fabricante,
        modelo: modeloName,
        funcao: funcaoName,
        proxy: proxys.find((p) => p.proxyid === form.proxy).host,
        groups: selectedGroups,
        templates: selectedTemplates,
        macros: selectedMacros,
        tipoInterface: form.tipoSNMP,
        ...(hostData &&
          (hostData?.id || hostData?.hostid || hostData?.hostId) &&
          (hostData?.interfaceId || hostData?.interfaceid) && {
            hostId: hostData?.id || hostData?.hostid || hostData?.hostId,
            interfaceId: hostData?.interfaceId || hostData?.interfaceid,
          }),
        statusPing: testsLocal.ping,
        statusSnmp: testsLocal.snmp,
      };
      const hostDataFormatted = {
        nome: nameIp
          ? form?.nome?.trim()
          : `${form?.nome?.trim()} - ${form?.ip?.trim()}`,
        ip: form.ip.trim(),
        ...(form.tipoSNMP !== "AGENTE" && {
          comunidade: form.comunidadeSnmp.trim(),
          userSsh: form.userSsh.trim() || null,
          senhaSsh: form.senhaSsh.trim() || null,
          portaSsh: Number(form.portaSsh) || null,
          userTelnet: form.userTelnet.trim() || null,
          senhaTelnet: form.senhaTelnet.trim() || null,
          portaTelnet: Number(form.portaTelnet) || null,
        }),
        portaSnmp: Number(form.portaSNMP),
        fabricante: form.fabricante,
        modelo: modeloName,
        funcao: funcaoName,
        proxy: proxys.find((p) => p.proxyid === form.proxy).proxyid,
        interfaceType: form.tipoSNMP === "AGENTE" ? "1" : "2",
        ...(hostData &&
          (hostData?.id || hostData?.hostid || hostData?.hostId) &&
          (hostData?.interfaceId || hostData?.interfaceid) && {
            id: hostData?.id || hostData?.hostid || hostData?.hostId,
            interfaceId: hostData?.interfaceId || hostData?.interfaceid,
          }),
        statusPing: testsLocal.ping,
        statusSnmp: testsLocal.snmp,
      };

      onSave(finalObject, hostDataFormatted);
      setErrors({});
    };

    useImperativeHandle(ref, () => ({
      close() {
        handleClose();
      },
    }));
    const handleClose = () => {
      setEditingHostData(null);
      setForm(initialFormState);
      setTouched({});
      setErrors({});
      setActiveStep(0);
      onClose();
    };

    const handleBack = () => {
      activeStep === 0
        ? handleClose()
        : setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const steps = [
      {
        label: "Configure o Host",
        description: (
          <ConfigureHost
            form={form}
            hostData={hostData}
            handleClose={handleClose}
            handleChange={handleChange}
            errors={errors}
            handleIpBlur={handleIpBlur}
            fabricantesOptions={fabricantesOptions}
            modelosDisponiveis={modelosDisponiveis}
            optionsTipoInterfaceSNMP={optionsTipoInterfaceSNMP}
            proxys={proxys}
            optionsTipoAcesso={optionsTipoAcesso}
            styles={styles}
          />
        ),
      },
      {
        label: "Testes de Conectividade",
        description: (
          <ConnectivityTests
            form={form}
            onTestingChange={setIsTesting}
            proxys={proxys}
            setTestsLocal={setTestsLocal}
          />
        ),
      },
      {
        label: hostData ? "Edição de Host" : "Cadastro de Host",
        description: (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={0.5}
            flex={1}
          >
            {!hasSubmitted || loading ? (
              <>
                <Stack
                  sx={{
                    backgroundColor: theme.palette.background.textField,
                    borderRadius: "100%",
                    height: 56,
                    width: 56,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress size={26} />
                </Stack>
                <Typography variant="subtitle1" color="text.primary">
                  {hostData ? "Editando" : "Cadastrando"} Host...
                </Typography>
                <Typography variant="subtitle2" color="text.secondary">
                  Isso pode levar alguns segundos
                </Typography>
              </>
            ) : (
              <>
                <Stack
                  sx={{
                    backgroundColor: alpha(theme.palette.error.main, 0.25),
                    borderRadius: "100%",
                    height: 46,
                    width: 46,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Close
                    sx={{
                      color: theme.palette.error.main,
                      height: 34,
                      width: 34,
                    }}
                  />
                </Stack>
                <Typography variant="subtitle1" color="error.main">
                  Ocorreu um erro ao {hostData ? "editar" : "cadastrar"} o host.
                </Typography>
                <Typography variant="subtitle2" color="text.secondary">
                  Por favor, tente novamente
                </Typography>
                <Button variant="outlined" onClick={handleBack} sx={{ mt: 2 }}>
                  Voltar
                </Button>
              </>
            )}
          </Box>
        ),
      },
    ];

    const verifyStep = () => {
      if (activeStep === 0) {
        const activeUser =
          form.tipoAcesso === "SSH" ? form.userSsh : form.userTelnet;
        const activeSenha =
          form.tipoAcesso === "SSH" ? form.senhaSsh : form.senhaTelnet;
        const activePorta =
          form.tipoAcesso === "SSH" ? form.portaSsh : form.portaTelnet;
        const hasUser = !!activeUser?.trim();
        const hasSenha = !!activeSenha?.trim();

        const hasErrors =
          !form.nome?.trim() ||
          !form.ip?.trim() ||
          !ipRegex.test(form.ip) ||
          (form.tipoSNMP !== "AGENTE" && !form.comunidadeSnmp?.trim()) ||
          !form.portaSNMP ||
          !form.fabricante ||
          !form.modelo ||
          (hasUser && (!activeSenha?.trim() || !activePorta)) ||
          (hasSenha && (!activeUser?.trim() || !activePorta));

        return hasErrors;
      }

      if (activeStep === 1) {
        return isTesting;
      }

      return false;
    };

    const handleNext = async () => {
      if (activeStep === 0) {
        const allFields = {
          nome: true,
          ip: true,
          fabricante: true,
          modelo: true,
          tipoSNMP: true,
          portaSNMP: true,
          comunidadeSnmp: true,
          userSsh: true,
          senhaSsh: true,
          portaSsh: true,
          userTelnet: true,
          senhaTelnet: true,
          portaTelnet: true,
        };
        setTouched(allFields);
        const newErrors = getFormErrors(form);
        if (Object.keys(newErrors).length > 0) {
          setErrors(newErrors);
          return;
        }
      }

      setErrors({});

      if (activeStep === 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        handleCreateHost();
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    };

    return (
      <>
        <Modal open={open}>
          <Paper sx={styles.paper}>
            <>
              <Box sx={styles.boxHeader}>
                <Box sx={styles.boxTitle}>
                  {activeStep == 0 ? (
                    <PlaylistAdd
                      sx={{ color: "primary.main", mr: 0.5 }}
                      fontSize="medium"
                    />
                  ) : (
                    <SignalCellularAltIcon
                      sx={{ color: "primary.main", mr: 0.5 }}
                      fontSize="medium"
                    />
                  )}

                  <Typography fontWeight={500}>
                    {hostData && activeStep == 0
                      ? "Editar Host"
                      : !hostData && activeStep == 0
                        ? "Cadastrar Host"
                        : "Testar conectividade"}
                  </Typography>
                </Box>
                <IconButton aria-label="close" onClick={handleClose}>
                  <Close />
                </IconButton>
              </Box>
              <Divider sx={{ mb: 2 }} />
            </>

            <Stepper
              activeStep={activeStep}
              orientation="horizontal"
              connector={<QontoConnector theme={theme} />}
            >
              {steps.map(({ label }) => (
                <Step key={label}>
                  <StepLabel>{isMobile ? "" : label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <Stack sx={{ height: "100%", flex: 1 }}>
              {steps[activeStep].description}
            </Stack>
            {activeStep !== steps.length - 1 && (
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Button variant="text" onClick={handleBack} size="small">
                  {activeStep === 0 ? "Cancelar" : "Voltar"}
                </Button>
                <LoadingButton
                  loading={loading}
                  variant="contained"
                  size="medium"
                  onClick={() => {
                    const { modelo: formModelo } = form;
                    const currentModeloLabel = hostData?.modelo?.toLowerCase();

                    const selectedModelo = modelosDisponiveis?.find(
                      (m) => m?.value === formModelo,
                    );
                    const selectedLabel = selectedModelo?.label?.toLowerCase();

                    if (
                      hostData &&
                      formModelo &&
                      selectedLabel &&
                      currentModeloLabel
                    ) {
                      if (
                        selectedLabel !== currentModeloLabel &&
                        activeStep === 1
                      ) {
                        return setOpenAlertModal(true);
                      }
                    }
                    handleNext();
                    //   handleCreateHost();
                  }}
                  disabled={verifyStep() || loading}
                  startIcon={
                    activeStep === 0 ? (
                      <PlayArrowOutlined />
                    ) : hostData ? (
                      <SaveAs />
                    ) : (
                      <Save />
                    )
                  }
                >
                  {activeStep === 1 && !hostData
                    ? "Cadastrar"
                    : activeStep === 1 && hostData
                      ? "Atualizar"
                      : "Iniciar testes"}
                </LoadingButton>
              </Stack>
            )}
          </Paper>
        </Modal>
        <NewAlertModal
          openModal={openAlertModal}
          setOpenModal={setOpenAlertModal}
          textContent={
            "O modelo foi alterado, e o histórico dos itens podem ser perdidos. Tem certeza que deseja alterar as informações do host? "
          }
          handleButton={() => {
            setOpenAlertModal(false);
            handleNext();
          }}
          severity={"warning"}
          singleButton={false}
        />
      </>
    );
  },
);

export default FormHostModal;
